<div class="container">
  <mat-form-field appearance="fill">
    <mat-label>רשימת עוגנים
      <span>({{anchors.length| number}})</span>
    </mat-label>
    <mat-chip-grid #chipList>
      @for (anchor of anchors; track anchor) {
        <mat-chip-row (removed)="remove(anchor)">
          {{ anchor }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      <input [placeholder]="'הזן ' + anchorType().anchorTypeLabel" [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="add($event)" autocomplete="off" />
        <label class="browse" (click)="clearAnchors()" matTooltip="נקה עוגנים">
          <mat-icon>clear_all</mat-icon>
        </label>
        <label class="browse" for="file-browse" matTooltip="טעינה מקובץ...">
          <mat-icon>upload</mat-icon>
        </label>
        <label class="browse" (click)="openDialog()" matTooltip="רשימת תוויות">
          <mat-icon>check_box</mat-icon>
        </label>

        <input #fileBrowse id="file-browse" type="file" accept=".txt" (change)="onChooseFile($event)" />
      </mat-chip-grid>
    </mat-form-field>

  </div>